import { Injectable, OnDestroy } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FrontendNetworkService implements OnDestroy {
  resumeOrNetworkChange$: Observable<boolean>;

  private readonly subscription = new Subscription();
  private readonly resumeOrNetworkChangeSource$ = new Subject<boolean>();

  constructor(private readonly platform: Platform) {
    this.resumeOrNetworkChange$ = this.resumeOrNetworkChangeSource$.asObservable();
  }

  socketConnectionRestored(): void {
    this.resumeOrNetworkChangeSource$.next(true);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
